import { useTranslation } from 'react-i18next';

export default () => {
    const { t } = useTranslation('pages');
    return (
        <h1>
            <a href="https://snapbeautify.pixzens.com" className="flex items-center text-xl font-bold text-purple-600 dark:text-purple-400">
                <img src="/favicon.svg" alt={t('about.logoText')} width="24" height="24" className="mr-2" />
                <span>{t('about.logoText')}</span>
            </a>
        </h1>
    )
};